import { render, staticRenderFns } from "./waterSystem.vue?vue&type=template&id=58a831fd&scoped=true&"
import script from "./waterSystem.vue?vue&type=script&lang=js&"
export * from "./waterSystem.vue?vue&type=script&lang=js&"
import style0 from "./waterSystem.vue?vue&type=style&index=0&id=58a831fd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a831fd",
  null
  
)

export default component.exports